import React from "react";
import DiaryRouter from './Diary/Router';
export { getFields, getReplyFields } from './Diary/Router';

export default function SiteDiaryRouter(props) {
    return (
        <DiaryRouter {...props} mode='SITE_DIARY' />
    );
};
